import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ContactTypes, ExtensionActivity, ExtensionActivityType} from '../../../../functions/src/types';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {UserService} from '../../services/user.service';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {DataService, ResolveCategory} from "../../services/data.service";
import {ReplaySubject, Subscription} from "rxjs";
import invert from "invert-color";
import {RSDialogService} from "../../../libs/rsnotify/rsdialog.service";
import * as moment from 'moment';
import {RSValidatorFormDirective} from "../../../libs/rsvalidator/rsvalidator.directive";
import {PracticeChangeService} from "../../services/practice-change.service";
import Style = RSDialog.Style;

@Component({
  selector: 'app-add-contact',
  templateUrl: './add-contact.component.html',
  styleUrls: ['./add-contact.component.scss']
})
export class AddContactComponent extends RSDialogComponentModel implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('form') inputForm: RSValidatorFormDirective;
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  contact: ExtensionActivity = {} as ExtensionActivity;
  contactTypes = Object.values(ContactTypes);
  ContactTypes = ContactTypes;

  activitySub: Subscription;
  activityTypes: ExtensionActivityTypeDisplay[] = [];
  selectActivity: ExtensionActivityTypeDisplay;
  selectPracticeChange: string;
  filteredActivities: ReplaySubject<ExtensionActivityTypeDisplay[]> = new ReplaySubject<ExtensionActivityTypeDisplay[]>(1);
  activitySearch = '';

  constructor(
    private userService: UserService,
    public dataService: DataService,
    public rsDialogService: RSDialogService,
    public practiceChangeService: PracticeChangeService,
    private resolveCategory: ResolveCategory) {
    super();
    this.activitySub = this.dataService.activityTypes.subscribe(v => {
      this.activityTypes = v.map(a => {
        const category = this.resolveCategory.transform(a.category);
        return {
          ...a,
          categoryName: category?.name,
          categoryColor: category?.color,
          categoryIcon: category?.icon,
          categoryArchived: category?.archived,
        } as ExtensionActivityTypeDisplay;
      });
      this.filterActivities();
    });
  }

  ngOnInit(): void {
    this.updateContactInfo(this.dialogValues?.contact || {});
    this.dialogValuesUpdated.subscribe(v => this.updateContactInfo(v?.contact || {}));
  }

  async removePracticeChange(value: string) {
    const pc = this.practiceChangeService.types[value];
    const field = pc.fieldId;
    const bSure = await this.rsDialogService.showConfirmDialog('Are you sure you want to delete this? You will lose all info entered.', false, 'Remove ' + pc.name, Style.WARN);
    if (bSure) {
      this.contact[field] = {};
    }
  }

  async addUpdatePracticeChange(value: string) {
    const pc = this.practiceChangeService.types[value];
    const field = pc.fieldId;
    if (typeof this.contact[field] !== 'object') {
      this.contact[field] = {};
    }
    console.log('Input', this.contact[field]);
    try {
      const result = await this.practiceChangeService.addPracticeChange(value, this.contact[field]);
      this.contact[field] = result.asObject();
      console.log('Output', this.contact[field]);
    } catch (e) {
      console.error(e);
    }
  }

  updateContactInfo(input: any) {
    this.contact = {
      id: input.id || null,
      date: typeof input.date === 'number' ? moment(input.date, 'X').toDate() : new Date(),
      type: input.type || ContactTypes.PHONE,
      user: input.user || this.userService.activeUserId,
      property: input.property || '',
      activities: input.activities || {},
      notes: input.notes || '',
      flagged: input.flagged === true || input.flagged === 'true' || false,

      pcFertiliser: input.pcFertiliser || {},
      pcWater: input.pcWater || {},
      pcPesticide: input.pcPesticide || {},
      pcSoil: input.pcSoil || {},
    } as ExtensionActivity;
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  activityById(activityId: string) {
    return this.activityTypes.find(at => at.id === activityId);
  }

  private _activitiesByCategoriesFor = null;
  private _activitiesByCategories: {key: string, type: ExtensionActivityTypeDisplay}[] = [];
  activitiesByCategories() {
    const items = Object.keys(this.contact.activities).join(',');
    if (this._activitiesByCategoriesFor !== items) {
      this._activitiesByCategories = Object.keys(this.contact.activities).map(v => {
        return {
          key: v,
          type: this.activityById(v)
        };
      })
      .sort(((a, b) => a.type.category.localeCompare(b.type.category)));
      this._activitiesByCategoriesFor = items;
    }
    return this._activitiesByCategories;
  }

  filterActivities() {
    // get the search keyword
    let search = this.activitySearch;
    if (!search) {
      this.filteredActivities.next(this.activityTypes.filter(a=>a.archived !== true && a.categoryArchived !== true).slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredActivities.next(
      this.activityTypes.filter(
        activity => (activity.name.toLowerCase().indexOf(search) > -1
                 || activity.categoryName.toLowerCase().indexOf(search) > -1) && (!activity.archived && !activity.categoryArchived)
      )
    );
  }

  addActivity(selectedActivity: ExtensionActivityTypeDisplay) {
    console.log('addActivity::: ', selectedActivity);
    if (!this.contact.activities) {
      this.contact.activities = {};
    }
    this.contact.activities[selectedActivity.id] = 1;
  }

  async addToActivity(activityId, value) {
    this.contact.activities[activityId] += value;
    if (this.contact.activities[activityId] === 0) {
      const bRemove = await this.rsDialogService.showConfirmDialog(
        'Do you want to remove this activity type?', false, 'Remove', RSDialog.Style.ERROR);
      if (bRemove) {
        delete this.contact.activities[activityId];
      } else {
        this.contact.activities[activityId]++;
      }
    }
  }

  cancel() {
    this.dialogHandles.close(RSDialog.defaultValues.CANCEL);
  }

  saveContact() {
    if (!this.inputForm.isValid(true)) {
      return;
    } else {
      const contact: ExtensionActivity = {} as ExtensionActivity;
      Object.assign(contact, this.contact);
      contact.date = +moment(contact.date).format('X');
      this.dialogValues.contact = contact;
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

  ngAfterViewInit(): void {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  ngOnDestroy() {
    if (this.activitySub) {
      this.activitySub.unsubscribe();
    }
    this.filteredActivities.complete();
  }

}

interface ExtensionActivityTypeDisplay extends ExtensionActivityType {
  categoryName: string;
  categoryIcon: string;
  categoryColor: string;
  categoryArchived: boolean;
}
